import { GetState, SetState } from 'zustand';
import { SettingsStore } from 'store';

export function switchEnhancedFraudEventSearch(set: SetState<SettingsStore>, get: GetState<SettingsStore>): void {
   const current: boolean = get().enhancedFraudEventSearch;

   set({ enhancedFraudEventSearch: !current });
}
